/**
 * Bereken de afstand tussen twee geografische coördinaten (in kilometers)
 * met behulp van de Haversine-formule.
 */
export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1 * Math.PI / 180) *
        Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

/**
 * Retrieve geographic coordinates (latitude/longitude) for a given postcode using the Google Maps Geocoding API.
 * @param {string} postcode - The postcode (e.g. '1234AB')
 * @param {string} apiKey - Google Maps API key
 * @returns {Promise<{lat: number, lon: number} | null>}
 */
export async function geocodePostcode(postcode, apiKey) {
    if (!isValidDutchPostcode(postcode)) {
        return null;
    }

    const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(postcode + ', Netherlands')}&key=${apiKey}`
    );

    const data = await response.json();

    if (data.status === 'OK' && data.results.length > 0) {
        const location = data.results[0].geometry.location;

        return {
            lat: location.lat,
            lon: location.lng
        };
    }

    return null;
}

// Validation function for Dutch postcodes
function isValidDutchPostcode(postcode) {
    return /^[1-9][0-9]{3}(\s?[a-zA-Z]{2})?$/.test(postcode.trim());
}